import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldStrom } from './functions/validateField';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeEnergiedatenEigenwaermeProps {
    data: any;
    standortSelected: any;
}

export interface DateneingabeEnergiedatenEigenwaermeState {
    jahr: number;
    monat: number;
}

export class DateneingabeEnergiedatenEigenwaerme extends
    React.Component<DateneingabeEnergiedatenEigenwaermeProps, DateneingabeEnergiedatenEigenwaermeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            jahr: null,
            monat: null
        };
        this.filterOptions = this.filterOptions.bind(this);
        this.getAbrechnungstage = this.getAbrechnungstage.bind(this);
        this.getEigenverbrauch = this.getEigenverbrauch.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    filterOptions?(options: Array<any>, key: string, data: any): Array<any> {
        const anlagen_eigenstrom: Array<any> = this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM] || [];
        const standort_energietraeger: Array<any> = this.props.data[IDs.ENT_STANDORT_ENERGIETRAEGER] || [];
        const { standort_tid } = data;
        const anlagen_eigenstrom_typen: Array<any> = (this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN] || [])
            .filter((item: any) => (item.typ || null) === 'W')
            .map((item: any) => item.tid);
        const energietraeger: Array<number> = (standort_tid && +standort_tid > 0
            ? standort_energietraeger
                .filter((item: any) => (item.standort_tid_orig || null) === standort_tid)
            : standort_energietraeger)
                .map((item: any) => item.energiedaten_waerme_energietraeger_tid_orig);
        const eigenstrom_typ: Array<number> = (standort_tid && +standort_tid > 0
            ? anlagen_eigenstrom
                .filter((item: any) => (item.standort_tid_orig || null) === standort_tid)
            : anlagen_eigenstrom)
                .filter((item: any) => anlagen_eigenstrom_typen.indexOf(item.anlagen_eigenstrom_typ_tid_orig || null) !== -1)
                .map((item: any) => item.anlagen_eigenstrom_typ_tid_orig)
                .filter(element => element !== undefined);

        switch (key) {
            case 'anlagen_eigenstrom_typ_tid':
                return (options && standort_tid && standort_tid > 0
                    ? options
                        .filter((item: any) => eigenstrom_typ.length === 0 || eigenstrom_typ.indexOf(item.tid || null) !== -1)
                    : options)
                        .filter((item: any) => (
                            anlagen_eigenstrom_typen.length === 0
                            || anlagen_eigenstrom_typen.indexOf(item.tid || null) !== -1)
                        );
            case 'energietraeger_tid':
                return options && standort_tid && standort_tid > 0
                    ? options
                        .filter((item: any) => (
                            item.tid
                            && energietraeger.length === 0 || energietraeger.indexOf(item.tid) > -1
                        ))
                    : options;
            default:
                return options;
        }
    }

    getAbrechnungstage(WFormData: any): void {
        const {
            abrechnungszeitraum_bis,
            abrechnungszeitraum_von
        } = WFormData.values;
        const tage: number = Moment.unix(abrechnungszeitraum_bis)
            .diff(Moment.unix(abrechnungszeitraum_von), 'days') + 1;
        WFormData.setValue('abrechnungstage', tage);
    }

    getEigenverbrauch(WFormData: any): void {
        const {
            gesamtproduktion_kwh,
            netzeinspeisung_kwh
        } = WFormData.values;
        let quote = 0;
        let verbrauch = 0;

        if (
            (+gesamtproduktion_kwh > 0 && +netzeinspeisung_kwh >= 0)
            && (+gesamtproduktion_kwh >= +netzeinspeisung_kwh)
        ) {
            verbrauch = +gesamtproduktion_kwh - +netzeinspeisung_kwh;
            quote = Math.round((verbrauch / +gesamtproduktion_kwh) * 100);
        }
        WFormData.setValue('eigenverbrauch_kwh', verbrauch);
        WFormData.setValue('eigenverbrauchsquote', quote);
    }

    onFormChange(WFormData: any): void {
        WFormData.setValue('datum', Moment().unix());
        const {
            abrechnungszeitraum_bis,
            abrechnungszeitraum_von,
            jahr,
            monat
        } = WFormData.values;

        if (
            typeof abrechnungszeitraum_von === 'undefined'
            || typeof abrechnungszeitraum_bis === 'undefined'
        ) {
            return;
        }
        const jahrAzBis: number = Moment(abrechnungszeitraum_bis, 'X').year();
        const jahrAzVon: number = Moment(abrechnungszeitraum_von, 'X').year();
        const monatAzBis: number = Moment(abrechnungszeitraum_bis, 'X').month();
        const monatAzVon: number = Moment(abrechnungszeitraum_von, 'X').month();
        const tagAzBis: number = Moment(abrechnungszeitraum_bis, 'X').date();
        const tagAzVon: number = Moment(abrechnungszeitraum_von, 'X').date();

        if (
            this.state.jahr !== null
            && jahr
            && jahr !== this.state.jahr
        ) {
            const azBis = Moment([+jahr, monatAzBis, tagAzBis]).invalidAt() !== -1
                ? Moment([+jahr, monatAzBis, 1]).endOf('month').unix()
                : Moment([+jahr, monatAzBis, tagAzBis]).unix();
            const azVon = Moment([+jahr, monatAzBis, tagAzBis]).invalidAt() !== -1
                ? Moment([+jahr, monatAzVon, 1]).startOf('month').unix()
                : Moment([+jahr, monatAzVon, tagAzVon]).unix();
            WFormData.setValue('abrechnungszeitraum_von', azVon);
            WFormData.setValue('abrechnungszeitraum_bis', azBis);
        }

        if (
            this.state.monat !== null
            && monat
            && monat !== this.state.monat
        ) {
            WFormData.setValue('abrechnungszeitraum_von', Moment(new Date(jahrAzVon, +monat - 1, 1)).unix());
            WFormData.setValue('abrechnungszeitraum_bis', Moment(new Date(jahrAzBis, +monat, 0)).unix());
        }
        this.getAbrechnungstage(WFormData);
        this.getEigenverbrauch(WFormData);
        this.setState({ jahr, monat });
    }

    preFilter(data: Array<any>): Array<any> {
        const { standortSelected } = this.props;

        return standortSelected
            ? data.filter((item: any) => (item.standort_tid_orig || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_ENERGIEDATEN_EIGENWAERME}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    addLabel={'Eigenwärme erfassen'}
                    onFormChange={this.onFormChange}
                    preFilterFunction={this.preFilter}
                    valueFieldSelectDefaultOptions={{ monat: 'Ganzes Jahr' }}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_EIGENWAERME)}
                    filterOptions={this.filterOptions}
                    validateField={this.validateField}
                />
            </div>
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldStrom(key, value, data, onValueChange);
    }
}
